// @flow

import * as React from "react";
import LinkHandler from "../atoms/LinkHandler";
import Pill from "../atoms/Pill";

type PropsType = {
    type: "event" | "club" | "product",
    section?: "bottom-content" | "left-content",
    categories?: any,
    title: string,
};

const CategorySection = (props: PropsType): React.Node => {
    const classList = ["category-section"];

    if (props.type) {
        classList.push(`category-section--${props.type}`);
    }

    if (props.section) {
        classList.push(`category-section--${props.section}`);
    }

    const tagList = props.categories
        ? props.categories.map((category, i): React.Node => {
              const categoryList = {
                  club: ["clubs", "club_category"],
                  event: ["events", "event_category"],
                  product: ["shop", "category"],
              };
              return (
                  <LinkHandler
                      key={i}
                      className="category-section__category__container"
                      to={`/${categoryList[props.type][0]}?${
                          categoryList[props.type][1]
                      }=${category.term_id || category.id}`}
                      target=""
                  >
                      <Pill
                          key={i}
                          color="stain"
                          size="lg"
                          className="category-section__category"
                          dangerouslySetInnerHTML={{
                              __html: category.name,
                          }}
                      ></Pill>
                  </LinkHandler>
              );
          })
        : null;

    return (
        <div className={classList.join(" ")}>
            <h2 className="category-section__title">{props.title}</h2>
            <div className="category-section__list">{tagList}</div>
        </div>
    );
};

export default CategorySection;
